import { Toast } from 'antd-mobile';
import axios from 'axios';

const request = axios.create({
  timeout: 5000,
  // baseURL: 'http://api.qgsaas.com/crm',
});

request.interceptors.response.use(
  async (res) => {
    if (res.data.success) {
      return res?.data?.result || res.data?.res;
    } else {
      !(res.config as any)?.quite && Toast.show({
        content: res.data.error,
        icon: 'fail',
      });
      return Promise.reject({
        ...res.data,
        error: res.data.error,
      });
    }
  },
  async (res) => {
    const _message = res.response.data.message || res.response.data.msg;
    Toast.show({
      content: _message,
      icon: 'fail',
    });
    return Promise.reject(res.response.data.message);
  },
);

export default request;
